var parent = require('../../es/object/define-property');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/define-property.js
// module id = 240
// module chunks = 0 1